import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
/*
 * Apollo link that does the fetching
 * Docs: https://www.apollographql.com/docs/link/links/http.html
 */

import { HttpLink } from 'apollo-link-http';
export var createDirectoryHttpLink = function createDirectoryHttpLink(_ref) {
  var url = _ref.url,
    getCloudId = _ref.getCloudId;
  var customFetch = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(uri, options) {
      var body, uriWithOps;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            body = JSON.parse(options.body);
            uriWithOps = body.operationName ? "".concat(uri, "?q=").concat(body.operationName) : uri;
            if (body.variables && body.variables._withCloudId && getCloudId) {
              delete body.variables._withCloudId;
              body.variables.cloudId = getCloudId();
              options.body = JSON.stringify(body);
            }
            return _context.abrupt("return", fetch(uriWithOps, options));
          case 4:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function customFetch(_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  return new HttpLink({
    uri: url,
    credentials: 'include',
    fetch: customFetch
  });
};